import { MrgActionTypes, MrgAction, GetUesrInforType } from "./mrgTypes";

export const postEmailForLoginActions = (email: string): MrgAction => ({
  type: MrgActionTypes.POST_EMAIL_FOR_LOGIN,
  payload: email,
});

export const setLoadingActions = (loading: boolean): MrgAction => ({
  type: MrgActionTypes.SET_LOADING,
  payload: loading,
});

export const getUserInforActions = (
  userInfor: Omit<GetUesrInforType, "group">
): MrgAction => ({
  type: MrgActionTypes.GET_USER_INFOR,
  payload: userInfor,
});

export const logOutActions = (): MrgAction => ({
  type: MrgActionTypes.LOG_OUT,
});
